import React, { useState, useEffect, useContext } from 'react';
import ContactNote from 'src/models/ContactNote';
import CardContainer from 'src/components/common/CardContainer.redesign';
// import DialogList from 'src/dialogs';
import OwnerContactNoteCard from './OwnerContactNoteCard';
import Ownership from 'src/models/tract_detail/Ownership';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import Card from 'src/components/common/Card.redesign';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import PagedResultSet from 'src/models/common/PagedResultSet';
import ProjectStaff from 'src/models/ProjectStaff';
import OwnershipContactCategoryForm from 'src/models/OwnershipContactCategoryForm';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import { useFetch } from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';

interface IOwnerContactNotesProps {
    ownershipContactCategories?: OwnershipContactCategoryForm;
    projectStaff?: PagedResultSet<ProjectStaff>;
    contactNotes: Array<ContactNote>;
    ownerLookUpId: number;
    ownerData: LeaseGenerationOwnerData;
    isReadonly?: boolean;

    hideDialog?: () => void;
    onEditContactNote: () => void;
}

const OwnerContactNotes = (props: IOwnerContactNotesProps) => {
    const dialogContext = useContext<dialogCreators>(DialogContext);
    const appContext = useContext<IAppContextState>(AppContext);
    const { del, response } = useFetch();

    const [selectedOwnership, setSelectedOwnership] = useState<Ownership>(null);
    const [sanitizedContactNoteList, setSanitizedContactNoteList] = useState<Array<ContactNote>>([]);
    const [currentContactNote, setCurrentContactNote] = useState<ContactNote>(undefined);

    useEffect(() => {
        if (props.contactNotes?.length > 0) {
            const tempContactNoteList: Array<ContactNote> = [];
            props.contactNotes.map((contactNote: ContactNote) => {
                if (tempContactNoteList.findIndex((x) => x.id === contactNote.id) === -1) {
                    tempContactNoteList.push(contactNote);
                }
            });
            setSanitizedContactNoteList(tempContactNoteList);
        } else {
            setSanitizedContactNoteList([]);
        }
    }, [props.ownerData]);

    // TODO: Is selectedOwnership a necessary state object?
    useEffect(() => {
        if (selectedOwnership) {
            dialogContext.owners.manageOwnership(
                selectedOwnership, 
                'Mineral', 
                'Contact Notes',
                props.projectStaff,
                props.ownershipContactCategories,
                false, 
                props.onEditContactNote,
                currentContactNote
            );    
        }
    }, [selectedOwnership]);

    const editContactNote = (ownershipInfo: ContactNote) => {
        const tempOwnership: Ownership = {
            id: ownershipInfo.ownershipId,
            ownerLookUpId: props.ownerLookUpId,
        };
        setCurrentContactNote(ownershipInfo);
        setSelectedOwnership(tempOwnership);
    };

    const onDeleteContactNote = async (contactNoteId: number) => {
        await del(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/contact-notes/${contactNoteId}`);

        if (response.ok) {
             props.onEditContactNote();
        }
    };

    return (
        <CardContainer 
            className="owner-tracts-results" 
            style={{ overflowY: 'scroll', maxHeight: '23vh' }}
        >
            <div>
                {sanitizedContactNoteList.length > 0 ? (
                    sanitizedContactNoteList.map((contactNote: ContactNote, index) => {
                        let contactNoteActions: ContextMenuAction[] = [
                            { text: 'Delete Note', action: () => onDeleteContactNote(contactNote.id) },
                        ];
                    
                        return (
                            <div key={`${index}.${contactNote.id}`} style={{ marginTop: '1rem' }}>
                                <OwnerContactNoteCard contactNote={contactNote} onEditContactNote={editContactNote} actions={contactNoteActions} />
                            </div>
                        );
                    })
                ) : (
                    <Card>
                        <p style={{ marginLeft: '1rem' }}>No Contact Notes</p>
                    </Card>
                )}
            </div>
        </CardContainer>
    );
};

export default OwnerContactNotes;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/OwnerContactNotes.tsx